import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checkbox_disabled",
  "use": "icon-checkbox_disabled-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"icon-checkbox_disabled\"><path d=\"M18 0c9.941 0 18 8.059 18 18s-8.059 18-18 18S0 27.941 0 18 8.059 0 18 0Zm9.035 11.306a1 1 0 0 0-1.414.004l-9.446 9.488-4.367-4.388a1.001 1.001 0 0 0-1.418 0l-1.973 1.982a1 1 0 0 0 0 1.411l4.374 4.395 2.676 2.688a1 1 0 0 0 1.418 0l12.127-12.183a1 1 0 0 0 0-1.41l-1.974-1.983a1.01 1.01 0 0 0-.003-.004Z\" fill=\"#CCC\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol